import { useParams } from 'react-router-dom'
import { Stack, Title } from '@mantine/core'
import { useAuthenticatedGraphQuery } from '@/hooks/use-authenticated-query'
import { AlertLevel, IconAlert } from '@shared/components/icon-alert/icon-alert'
import { SoldWoolSummaryChart } from '@shared/components/wool-data/sold-wool-summary/sold-wool-summary-chart'
import { SoldWoolSummaryTable } from '@shared/components/wool-data/sold-wool-summary/sold-wool-summary-table'
import { getSeasonYear } from '@shared/helpers/get-season-year/get-season-year'
import { GetSoldWoolSummaryGql } from '@/graphql/queries/wool-data/get-sold-wool-summary.graphql'

export function ClipSummary() {
  // Get the station record number from the URL
  const { stationRecordNumber } = useParams()

  const firstSeason = getSeasonYear(new Date())

  // Get the Sold Wool Summary data
  const { data, isLoading, isError, error } = useAuthenticatedGraphQuery({
    queryKey: ['soldWoolSummaryData', stationRecordNumber, firstSeason],
    gql: GetSoldWoolSummaryGql,
    queryParams: {
      stationRecordNumber,
      firstSeason,
    },
    enabled: !!stationRecordNumber && !!firstSeason,
  })

  if (isError && error.response?.status === 403) {
    return (
      <Stack>
        <Title order={2} data-testid='station-wool-data-clip-summary'>
          Clip Summary
        </Title>
        <IconAlert
          title='Restricted Access'
          level={AlertLevel.WARNING}
          message='You do not have permission to view clip summary for this station.'
        />
      </Stack>
    )
  }

  return (
    <>
      <Stack>
        <Title order={2} data-testid='station-wool-data-clip-summary' mr='auto'>
          Sold Wool Summary
        </Title>

        <SoldWoolSummaryChart data={data?.listSoldWoolSummary?.results} />

        <SoldWoolSummaryTable
          data={data?.listSoldWoolSummary?.results}
          isError={isError}
          isLoading={isLoading}
        />
      </Stack>
    </>
  )
}
